// extracted by css-extract-rspack-plugin
export default {"icon":"S7_lXEzyYycWm3uM"};